<app-header></app-header>
<ng-container [ngSwitch]="desktopTemplate">
    <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="xsmode"></ng-container>
    <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="xsmode"></ng-container>
    <ng-container *ngSwitchCase="'md'" [ngTemplateOutlet]="xsmode"></ng-container>
    <ng-container *ngSwitchDefault [ngTemplateOutlet]="bigmode"></ng-container>
</ng-container>


<ng-template #xsmode>
    <div class="wrapper">
        <ng-container *ngIf="!loading else myloading">
            <h2 class="sh2mobile">Hier sind unsere Top-Ergebnisse für Sie:</h2>
            <div class="cc50wrappermobile">
                <ng-container *ngIf="searchres?.length > 0 else notfound">
                    <div class="cc50mobile customscroll" (scroll)="$event.stopPropagation()">
                        <ng-container *ngFor="let obj of searchres">
                            <button class="cc50-itemmobile" (click)="gotofirst(obj, $event)">
                                <div class="cc51mobile">
                                    <!-- <span class="cc50-title">{{obj.name}}</span> -->
                                    <ng-container *ngIf="obj?.sktvbestellnummer?.length > 0">
                                        <div class="ccsjtv" [innerHtml]="obj.sktvbestellnummer | safehtml"></div>
                                    </ng-container>
                                    <div class="cc50-title" [innerHtml]="obj.displayname | safehtml"></div>
                                    <ng-container *ngIf="obj.subtext?.length > 0">
                                        <span class="cc50-item-subtext">{{obj.subtext}}</span>
                                    </ng-container>
                                </div>
                                <div class="cc52mobile">
                                    @if(obj.isPauschal) {
                                    <button class="cc53mobile" (click)="gotoPauschal(obj, $event)">Pauschal</button>
                                    }
                                    <button class="cc53mobile" *ngIf="obj.isHotelonly"
                                        (click)="gotoHotel(obj, $event)">Hotel</button>
                                    <button class="cc53mobile" *ngIf="obj.isRailtravel"
                                        (click)="gotoRail(obj, $event)">Bahn +
                                        Hotel</button>
                                    <button class="cc53mobile" *ngIf="obj.isFlight"
                                        (click)="gotoFlight(obj, $event)">Flug</button>
                                    <button class="cc53mobile" *ngIf="obj.isCarrent"
                                        (click)="gotoCarrent(obj, $event)">Mietwagen</button>
                                    <button class="cc53mobile" *ngIf="obj.isCruise"
                                        (click)="gotoCruise(obj, $event)">Kreuzfahrten</button>
                                    <button class="cc53mobile"
                                        *ngIf="obj.isFerienhauser"
                                        (click)="gotoFerienhauser(obj, $event)">Ferienhäuser</button>
                                    <button class="cc53mobile" *ngIf="obj.isContent"
                                        (click)="gotoContent(obj, $event)">Travelfacts</button>
                                    <button class="cc53mobile" *ngIf="obj.isTvangebote"
                                        (click)="gotoSktv(obj, $event)">TV-Angebote</button>
                                    @if(obj.isGolfplatz) {
                                    <button class="cc53mobile" (click)="gotoGolfPlz(obj, $event)">Golfplatz</button>
                                    }
                                    @if(obj.isGolfHotels) {
                                    <button class="cc53mobile" (click)="gotoGolfHotel(obj, $event)">Golfhotel</button>
                                    }
                                    @if(obj.isJtHotels) {
                                    <button class="cc53mobile" (click)="gotoJtHotel(obj, $event)">JT-Hotel</button>
                                    }
                                </div>
                            </button>
                        </ng-container>
                    </div>
                    <!-- <div class="cc50footer">
                        <button class="wbtn">weitere Ergebnisse anzeigen</button>
                    </div> -->
                </ng-container>
                <callcenterusers [partner]="partner" class="w100"></callcenterusers>
            </div>
        </ng-container>
    </div>
</ng-template>

<ng-template #bigmode>
    <div class="wrapper">
        <ng-container *ngIf="!loading else myloading">
            <h2 class="sh2">Hier sind unsere Top-Ergebnisse für Sie:</h2>
            <div class="cc50wrapper">
                <ng-container *ngIf="searchres?.length > 0 else notfound">
                    <div class="cc50 customscroll">
                        <ng-container *ngFor="let obj of searchres">
                            <button class="cc50-item" (click)="gotofirst(obj, $event)">
                                <div class="cc51">
                                    @if(obj?.sktvbestellnummer?.length > 0) {
                                    <div class="ccsjtv" [innerHtml]="obj.sktvbestellnummer | safehtml"></div>
                                    }
                                    <!-- @if(obj?.GolfplatzID?.length > 0) {
                                        <div class="ccsjtv" [innerHtml]="obj.GolfplatzID | safehtml"></div>
                                    } -->
                                    <!-- <span class="cc50-title">{{obj.name}}</span> -->
                                    <div class="cc50-title" [innerHtml]="obj.displayname | safehtml"></div>
                                    @if(obj.subtext?.length > 0) {
                                    <span class="cc50-item-subtext">{{obj.subtext}}</span>
                                    }
                                </div>
                                <div class="cc52">
                                    <button class="cc53" *ngIf="obj.isPauschal"
                                        (click)="gotoPauschal(obj, $event)">Pauschal</button>
                                    <button class="cc53" *ngIf="obj.isHotelonly"
                                        (click)="gotoHotel(obj, $event)">Hotel</button>
                                    <button class="cc53" *ngIf="obj.isRailtravel" (click)="gotoRail(obj, $event)">Bahn +
                                        Hotel</button>
                                    <button class="cc53" *ngIf="obj.isFlight"
                                        (click)="gotoFlight(obj, $event)">Flug</button>
                                    <button class="cc53" *ngIf="obj.isCarrent"
                                        (click)="gotoCarrent(obj, $event)">Mietwagen</button>
                                    <button class="cc53" *ngIf="obj.isCruise"
                                        (click)="gotoCruise(obj, $event)">Kreuzfahrten</button>
                                    <button class="cc53"
                                        *ngIf="obj.isFerienhauser"
                                        (click)="gotoFerienhauser(obj, $event)">Ferienhäuser</button>
                                    <button class="cc53" *ngIf="obj.isContent"
                                        (click)="gotoContent(obj, $event)">Travelfacts</button>
                                    <button class="cc53" *ngIf="obj.isTvangebote"
                                        (click)="gotoSktv(obj, $event)">TV-Angebote</button>
                                    @if(obj.isGolfplatz) {
                                    <button class="cc53" (click)="gotoGolfPlz(obj, $event)">Golfplatz</button>
                                    }
                                    @if(obj.isGolfHotels) {
                                    <button class="cc53" (click)="gotoGolfHotel(obj, $event)">Golfhotel</button>
                                    }
                                    @if(obj.isJtHotels) {
                                    <button class="cc53" (click)="gotoJtHotel(obj, $event)">JT-Hotel</button>
                                    }
                                </div>
                            </button>
                        </ng-container>
                    </div>
                    <!-- <div class="cc50footer">
                        <button class="wbtn">weitere Ergebnisse anzeigen</button>
                    </div> -->
                </ng-container>
                <callcenterusers [partner]="partner" class="w100 mt1rem"></callcenterusers>
            </div>
        </ng-container>
    </div>
</ng-template>


<ng-template #myloading>
    <div class="loading">
        <h3 class="h33">Suchen...</h3>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</ng-template>

<ng-template #notfound>
    <div class="cc54">Keine Ergebnisse gefunden</div>
</ng-template>
<footer></footer>